module.exports = __webpack_public_path__ + "img/rounded-question.389c65c4.svg";